import React, { useEffect, useState } from 'react'
import { Icon } from 'semantic-ui-react'

type PreviewImageProps = {
  src: string
  loadingElement?: JSX.Element
  errorElement?: JSX.Element
}

const PreviewImage = ({ src, loadingElement, errorElement }: PreviewImageProps) => {
  const [imageError, setImageError] = useState(false)
  const [loading, setLoading] = useState(true)

  const loadingElementInternal = loadingElement ? loadingElement : <Icon loading name="spinner" size="big"/>
  const errorElementInternal = errorElement ? errorElement : <div>Error loading the image.</div>

  useEffect(() => {
    setImageError(false)
    setLoading(true)
  }, [src])

  const handleError = () => {
    setImageError(true)
    setLoading(false)
  }

  return (
    <>
      {loading && loadingElementInternal}
      {!imageError &&
          <img src={src}
               alt={'Frame Preview'}
               onLoad={() => setLoading(false)}
               onError={handleError}
               style={loading ? { display: 'none' } : {}}
          />}
      {imageError && errorElementInternal}
    </>
  )
}

export default PreviewImage